import type { ProgramUserRsvp } from 'models';
import type { EventActionsView } from '../../types';
import { PastRsvpStatusTag } from '../past-rsvp-status-tag';
import { EventDropdownButton, type EventDropdownButtonProperties } from './event-dropdown-button';
import { EventJoinButtons, type EventJoinButtonsProperties } from './event-join-buttons';
import { EventRsvpButtons, type EventRsvpButtonsProperties } from './event-rsvp-buttons';

type P = {
  currentUserRsvp?: ProgramUserRsvp;
  dropdownButton: EventDropdownButtonProperties;
  isAfterJoinPeriod: boolean;
  isJoinPeriod: boolean;
  joinButton: EventJoinButtonsProperties;
  rsvpButtons: EventRsvpButtonsProperties;
  view: EventActionsView;
};

const EventActionsButtons = ({
  currentUserRsvp,
  dropdownButton,
  isAfterJoinPeriod,
  isJoinPeriod,
  joinButton,
  rsvpButtons,
  view,
}: P) => {
  if (isAfterJoinPeriod) {
    return <PastRsvpStatusTag status={currentUserRsvp} view={view} />;
  }

  if (currentUserRsvp === 'pending') {
    return <EventRsvpButtons rsvpButtons={rsvpButtons} view={view} />;
  }

  if (isJoinPeriod) {
    return <EventJoinButtons joinButton={joinButton} view={view} />;
  }

  return <EventDropdownButton dropdownButton={dropdownButton} view={view} />;
};

export default EventActionsButtons;
